import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleSubscribe } from '../reducers/subReducer';
import { notify } from '../reducers/notificationReducer';
import SubFormModal from './SubFormModal';
// import LoadingSpinner from './LoadingSpinner';
import SkeletonText from './SkeletonText';
import SkeletonPanl from './SkeletonPanl';
import SkeletonHive from './SkeletonHive';

import getErrorMsg from '../utils/getErrorMsg';
import storageService from '../utils/localStorage';
import 'boxicons';
import { ReactComponent as TopPanl} from '../svg/topPanl.svg';
import { ReactComponent as HiveIcone } from '../svg/HiveIcone.svg';


import {
  Paper,
  Typography,
  useMediaQuery,
  Link,
  Button,
  SvgIcon,
} from '@material-ui/core';
import { useSubPanelStyles } from '../styles/muiStyles';
import { useTheme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';

const TopSubsPanel = () => {
  const { subs, user } = useSelector((state) => state);
  const dispatch = useDispatch();
  const classes = useSubPanelStyles();
  const theme = useTheme();
  const isNotDesktop = useMediaQuery(theme.breakpoints.down('md'));

  if (isNotDesktop) {
    return null;
  }

  const loggedUser = storageService.loadUser() || user;

  const loadingSubs = !subs || !subs.topSubs;

  const isSubscribed = (subscribedBy, user) => {
    return subscribedBy.includes(user.id);
  };

  const handleJoinSub = async (id, subscribedBy, subredditName) => {
    try {
      let updatedSubscribedBy;

      if (subscribedBy.includes(user.id)) {
        updatedSubscribedBy = subscribedBy.filter((s) => s !== user.id);
      } else {
        updatedSubscribedBy = [...subscribedBy, user.id];
      }
      dispatch(toggleSubscribe(id, updatedSubscribedBy));

      let message = subscribedBy.includes(user.id)
        ? `Unfollowed ${subredditName}`
        : `Followed ${subredditName}!`;
      dispatch(notify(message, 'success'));
    } catch (err) {
      dispatch(notify(getErrorMsg(err), 'error'));
    }
  };

  return (
    <Paper variant="outlined" className={classes.mainPaper}>
      {loadingSubs ? (
          <SkeletonPanl />
        ) : (
         <Typography variant="h5" color="secondary" className={classes.title}>
          <div >
          Trending Hives
          <TopPanl className={classes.imgPaper} /> 
          </div>
        </Typography>
        )}
        <Paper variant="outlined" className={classes.listPaper}>
        {loadingSubs ? (
          <SkeletonText />
        ) : (
          subs.topSubs.map((s, i) => (
            <div key={s.id} className={classes.listWrapper}>
              <Typography variant="body2" className={classes.listItem}>
                <Link
                  component={RouterLink}
                  to={`/r/${s.subredditName}`}
                  color="primary"
                >
                  <box-icon name='hive' color="gray" animation="tada-hover"size="17px" flip="horizontal"></box-icon> {s.subredditName}
                </Link>
              </Typography>
              {loggedUser && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="x-small"
                  startIcon={
                    isSubscribed(s.subscribedBy, user) ? (
                      <CheckIcon />
                    ) : (
                      <AddIcon />
                    )
                  }
                  onClick={() =>
                    handleJoinSub(s.id, s.subscribedBy, s.subredditName)
                  }
                >
                  {isSubscribed(s.subscribedBy, user) ? 'Followed' : 'Follow'}
                </Button>
              )}
            </div>
          ))
        )}
      </Paper>
            <div>
              
      </div>
      {loadingSubs ? (
          <SkeletonHive />
        ) : (
      <Paper variant="outlined" style={{marginTop:20 , paddingBottom:30}} className={classes.listPaper}>
      <div  className={classes.panlPaper} >
      <HiveIcone style={{marginTop:50  , marginLeft:-50 }}/>
      </div>
      <div style={{margin:'auto' }} >

      </div>
      {loggedUser && <SubFormModal />}
     <div  style={{marginTop:25 , fontSize:10 , color:'Gray' , textAlign:'center', }}>
       © 2021 Hive Cycle
     </div>
      </Paper>
        )}
    </Paper>
  );
};

export default TopSubsPanel;
